"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingChecklistResponseT = exports.TrackingChecklistResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const tracking_checklist_step_js_1 = require("../../solarxr-protocol/rpc/tracking-checklist-step.js");
class TrackingChecklistResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackingChecklistResponse(bb, obj) {
        return (obj || new TrackingChecklistResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackingChecklistResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackingChecklistResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    steps(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new tracking_checklist_step_js_1.TrackingChecklistStep()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    stepsLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    ignoredSteps(index) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    ignoredStepsLength() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    ignoredStepsArray() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    static startTrackingChecklistResponse(builder) {
        builder.startObject(2);
    }
    static addSteps(builder, stepsOffset) {
        builder.addFieldOffset(0, stepsOffset, 0);
    }
    static createStepsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startStepsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addIgnoredSteps(builder, ignoredStepsOffset) {
        builder.addFieldOffset(1, ignoredStepsOffset, 0);
    }
    static createIgnoredStepsVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startIgnoredStepsVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static endTrackingChecklistResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTrackingChecklistResponse(builder, stepsOffset, ignoredStepsOffset) {
        TrackingChecklistResponse.startTrackingChecklistResponse(builder);
        TrackingChecklistResponse.addSteps(builder, stepsOffset);
        TrackingChecklistResponse.addIgnoredSteps(builder, ignoredStepsOffset);
        return TrackingChecklistResponse.endTrackingChecklistResponse(builder);
    }
    unpack() {
        return new TrackingChecklistResponseT(this.bb.createObjList(this.steps.bind(this), this.stepsLength()), this.bb.createScalarList(this.ignoredSteps.bind(this), this.ignoredStepsLength()));
    }
    unpackTo(_o) {
        _o.steps = this.bb.createObjList(this.steps.bind(this), this.stepsLength());
        _o.ignoredSteps = this.bb.createScalarList(this.ignoredSteps.bind(this), this.ignoredStepsLength());
    }
}
exports.TrackingChecklistResponse = TrackingChecklistResponse;
class TrackingChecklistResponseT {
    constructor(steps = [], ignoredSteps = []) {
        this.steps = steps;
        this.ignoredSteps = ignoredSteps;
    }
    pack(builder) {
        const steps = TrackingChecklistResponse.createStepsVector(builder, builder.createObjectOffsetList(this.steps));
        const ignoredSteps = TrackingChecklistResponse.createIgnoredStepsVector(builder, this.ignoredSteps);
        return TrackingChecklistResponse.createTrackingChecklistResponse(builder, steps, ignoredSteps);
    }
}
exports.TrackingChecklistResponseT = TrackingChecklistResponseT;
